import { toast } from 'react-toastify'
import {
  getAllIncidents,
  getAllSchoolMembers,
  getIncidentById,
} from '../../api/admin/incidents'
import {
  incidentData,
  incidentDataCountObj,
  incidentDataResponse,
  // incidentDataResponseObject,
  incidentDataResponseObject2,
  schoolMembers,
  schoolMembersResponse,
} from '../../utils/types'

export const getIncidentData = async (
  // currentPage: number,
  sortBy: string,
  sortOrderValue: string
): Promise<incidentDataCountObj> => {
  const response = (await getAllIncidents(
    // currentPage,
    sortBy,
    sortOrderValue
  )) as incidentDataResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getIncidentDataById = async (
  id: string
): Promise<incidentData> => {
  const response = (await getIncidentById(id)) as incidentDataResponseObject2

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
export const getAllCandidates = async (): Promise<schoolMembers[]> => {
  const response = (await getAllSchoolMembers()) as schoolMembersResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
